<template>
  <div class="transportation-route-container d-flex flex-sm-column flex-lg-row justify-content-lg-between">
    <TransportationStopsContainerComponent :transportation-data="data" />
    <CustomRouteMapTemplateComponent class="map-modal-container-width" :map-id="`map-${data.id}`" />
  </div>
</template>

<script lang="ts">
import type { IApiResponseTransportation } from "@/interfaces/apiResponseInterfaces/IApiResponseTransportation.interface";
import {defineComponent, type PropType} from "vue";
// @ts-ignore
import TransportationStopsContainerComponent from "../transportationStopsContainer/TransportationStopsContainerComponent.vue";
// @ts-ignore
import CustomRouteMapTemplateComponent from "../customRouteMapTemplate/CustomRouteMapTemplateComponent.vue";
import type {Coordinates} from "@/store/states/ICoordinatesState.interface";
// @ts-ignore
import originIcon from "/assets/images/start-icon-last-1.svg";
// @ts-ignore
import destinationIcon from "/assets/images/destination-icon-last-1.svg";
// @ts-ignore
import waypointIcon from "/assets/images/waypoint-icon.svg";
import apiGoogleService from "../../services/apiGoogleService";
import apiTransportationsService from "../../services/apiTransportationsService";
import type {Coords} from "@/store/states/ICoordinatesState.interface";

export default defineComponent({
  name: "TransportationStopsModalContentComponent",
  components: {
    CustomRouteMapTemplateComponent,
    TransportationStopsContainerComponent
  },

  data() {
    return {
      icons: {
        origin: originIcon,
        destination: destinationIcon,
        waypoint: waypointIcon
      },
      coordinates: <Coordinates|null>null
    }
  },

  props: {
    data: {
      type: Object as PropType<IApiResponseTransportation>,
      required: true
    }
  },


  methods: {
    extractCoordinates(state: IApiResponseTransportation): Coordinates {
      return {
        origin: {
          lat: parseFloat(state.pickup_city.lat as string),
          lng: parseFloat(state.pickup_city.lng as string),
        },
        destination: {
          lat: parseFloat(state.dropoff_city.lat as string),
          lng: parseFloat(state.dropoff_city.lng as string)
        },
        waypoints: state.transportation_stop.map(stop => {
          return {
            location: {
              lat: parseFloat(stop.transportation_address.lat as string),
              lng: parseFloat(stop.transportation_address.lng as string)
            }
          }
        })
      }
    }
  },

  mounted() {
    const mapResponse = typeof this.data.map_response === 'string' ? JSON.parse(this.data.map_response)[0] : this.data.map_response;

    const directionsRenderer = apiGoogleService.directionsRenderer();
    const map = apiGoogleService.initMap(apiGoogleService.COUNTRY_CENTER_COORDINATES_LT, `map-${this.data.id}`);

    this.coordinates = this.extractCoordinates(this.data);

    directionsRenderer.setMap(map);
    // directionsRenderer.setDirections(this.data.map_response);
    if (mapResponse !== null) {
      directionsRenderer.setDirections(mapResponse);
    }

    apiTransportationsService.displayTransportationMarkers(map, this.coordinates, this.icons, this.data);

    const mapContainer = document.getElementById(`map-${this.data.id}`);
    mapContainer!.style.height = '450px';
  }
})
</script>

<style scoped lang="scss">
@import "./transportationStopsModalContent.scss";
</style>